import GroupPage from "./GroupPage";
import { IMAGES } from "@/data/content";

export default function Gangs() {
  return (
    <GroupPage
      path="gangs"
      sectionKey="gangs"
      defaultImage={IMAGES.duskRider}
      title="Gangs"
      overline="Outlaws of Aurora Springs"
      sub="Where there's law, there's those who break it. Meet the gangs, rustlers and bootleggers who ride the wrong side of the frontier."
      emptyText="No gangs listed yet — add them from the admin panel."
    />
  );
}
